import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserDinerGameProps {
    onComplete: () => void;
}

interface PhaserDinerGameState {
}

const templateConfig: GameConfig = {
    title: "Navigation Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserDinerGame extends React.Component<PhaserDinerGameProps, PhaserDinerGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserDinerGameProps) {
        super(props);
        bindAllOfThis(this, PhaserDinerGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={templateConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserDinerGame;



// WEBPACK FOOTER //
// ./src/games/DinerGame/Main.tsx